import { render, staticRenderFns } from "./transportModel.vue?vue&type=template&id=4b942622&scoped=true"
import script from "./transportModel.vue?vue&type=script&lang=js"
export * from "./transportModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b942622",
  null
  
)

export default component.exports